// import React, { useRef, useState, useEffect } from 'react';
// import html2pdf from 'html2pdf.js';
// import axios from 'axios';

// const JobApplicationFormShareable = ({ onClose }) => {
//   const [formData, setFormData] = useState({
//     positionAppliedFor: '',
//     title: '',
//     surname: '',
//     firstName: '',
//     otherNames: '',
//     address: '',
//     email: '',
//     phoneNumber: '',
//     preferredContact: '',
//     unavailableDates: '',
//     eligibleNigeria: '',
//     eligibilityDocuments: '',
//     criminalConvictions: '',
//     unspentConvictionsDetails: '',
//     currentEmployerName: '',
//     currentEmployerAddress: '',
//     natureOfBusiness: '',
//     jobTitle: '',
//     dateJoined: '',
//     dateStartedCurrent: '',
//     noticePeriod: '',
//     currentSalary: '',
//     mainTasks: '',
//     reasonForLeaving: '',
//     employmentHistory: [
//       { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }
//     ],
//     secondarySchool: '',
//     secondaryExams: '',
//     secondaryGrades: '',
//     furtherEducation: '',
//     professionalOrg: '',
//     gradeOfMembership: '',
//     jobTraining: '',
//     skillsInfo: '',
//     ref1Name: '',
//     ref1Company: '',
//     ref1Address: '',
//     ref1JobTitle: '',
//     ref1Relationship: '',
//     ref1Phone: '',
//     ref1Fax: '',
//     ref1Email: '',
//     ref2Name: '',
//     ref2Company: '',
//     ref2Address: '',
//     ref2JobTitle: '',
//     ref2Relationship: '',
//     ref2Phone: '',
//     ref2Fax: '',
//     ref2Email: '',
//     signature: '',
//     date: '',
//   });

//   const [whatsappNumber, setWhatsappNumber] = useState('');
//   const componentRef = useRef(null);
//   const [downloadCount, setDownloadCount] = useState(0);
//   const [isLoading, setIsLoading] = useState(true);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleEmploymentHistoryChange = (index, field, value) => {
//     const updatedHistory = formData.employmentHistory.map((item, i) =>
//       i === index ? { ...item, [field]: value } : item
//     );
//     setFormData(prev => ({ ...prev, employmentHistory: updatedHistory }));
//   };

//   const addEmploymentEntry = () => {
//     setFormData(prev => ({
//       ...prev,
//       employmentHistory: [...prev.employmentHistory, { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }]
//     }));
//   };

//   const trackEvent = async (action) => {
//     try {
//       await axios.post(`${process.env.REACT_APP_API_URL}analytics/track-action`, {
//         action,
//         form: 'JobApplicationForm',
//         timestamp: new Date().toISOString(),
//       });
//       fetchDownloadCount();
//     } catch (error) {
//       console.error('Tracking error:', error);
//       const key = `jobForm_${action}_count`;
//       const currentCount = parseInt(localStorage.getItem(key) || '0', 10);
//       localStorage.setItem(key, currentCount + 1);
//       if (action === 'download') setDownloadCount(currentCount + 1);
//     }
//   };

//   const fetchDownloadCount = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}analytics/form-analytics`);
//       setDownloadCount(response.data.downloadCount);
//     } catch (error) {
//       console.error('Error fetching download count:', error);
//       const localCount = parseInt(localStorage.getItem('jobForm_download_count') || '0', 10);
//       setDownloadCount(localCount);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchDownloadCount();
//   }, []);

//   const handleDownload = () => {
//     if (!componentRef.current) {
//       alert('Error: Form content is not available for download.');
//       return;
//     }
//     trackEvent('download');
//     const element = componentRef.current;
//     const opt = {
//       margin: 1,
//       filename: 'Job_Application_Form.pdf',
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
//     };
//     html2pdf().set(opt).from(element).save();
//   };

//   const handlePrint = () => {
//     if (!componentRef.current) {
//       alert('Error: Nothing to print. Please try again.');
//       return;
//     }
//     trackEvent('print');
//     window.print();
//   };

//   const handleShare = async () => {
//     if (!navigator.share) {
//       alert('Web Share API is not supported in your browser. Please download the PDF and share it manually.');
//       return;
//     }
//     if (!componentRef.current) {
//       alert('Error: Form content is not available for sharing.');
//       return;
//     }
//     const element = componentRef.current;
//     const opt = {
//       margin: 1,
//       filename: 'Job_Application_Form.pdf',
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
//     };
//     try {
//       const pdfBlob = await html2pdf().set(opt).from(element).toPdf().output('blob');
//       const file = new File([pdfBlob], 'Job_Application_Form.pdf', { type: 'application/pdf' });
//       trackEvent('share');
//       await navigator.share({
//         title: 'Job Application Form',
//         text: 'Here is my completed job application form.',
//         files: [file],
//       });
//     } catch (error) {
//       console.error('Share error:', error);
//       alert('Failed to share the form. Please download and share manually.');
//     }
//   };

//   const handleSendToWhatsApp = () => {
//     if (!whatsappNumber) {
//       alert('Please enter a valid WhatsApp number.');
//       return;
//     }
//     const cleanedNumber = whatsappNumber.replace(/\D/g, '');
//     const message = encodeURIComponent('Here is my job application form. Please find the PDF attached.');
//     const whatsappUrl = `https://wa.me/${cleanedNumber}?text=${message}`;
//     trackEvent('whatsapp');
//     alert('Please download the PDF first and attach it in WhatsApp after clicking OK.');
//     handleDownload();
//     window.open(whatsappUrl, '_blank');
//   };

//   return (
//     <div className="fixed inset-0 bg-gray-900 bg-opacity-60 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto p-8">
//         <div className="flex justify-between items-center mb-8">
//           <h1 className="text-3xl font-extrabold text-gray-900">Job Application Form</h1>
//           <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl font-bold transition-colors">&times;</button>
//         </div>

//         {/* Action Buttons and Download Count */}
//         <div className="flex flex-wrap gap-4 mb-8 items-center">
//           <button
//             onClick={handlePrint}
//             className="bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-6 rounded-lg transition-colors"
//           >
//             Print Form
//           </button>
//           <button
//             onClick={handleDownload}
//             className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-6 rounded-lg transition-colors"
//           >
//             Download PDF
//           </button>
//           <button
//             onClick={handleShare}
//             className="bg-purple-500 hover:bg-purple-600 text-white font-medium py-2 px-6 rounded-lg transition-colors"
//           >
//             Share Form
//           </button>
//           <div className="flex items-center gap-2">
//             <input
//               type="tel"
//               value={whatsappNumber}
//               onChange={(e) => setWhatsappNumber(e.target.value)}
//               placeholder="Enter WhatsApp Number"
//               className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//             <button
//               onClick={handleSendToWhatsApp}
//               className="bg-teal-500 hover:bg-teal-600 text-white font-medium py-2 px-6 rounded-lg transition-colors"
//             >
//               Send to WhatsApp
//             </button>
//           </div>
//           <div className="ml-auto text-sm text-gray-500">
//             {isLoading ? 'Loading download count...' : `Downloads: ${downloadCount}`}
//           </div>
//         </div>

//         {/* Form Content */}
//         <div ref={componentRef} className="space-y-10">
//           {/* Position Applied For */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Position Applied For</h2>
//             <input
//               type="text"
//               name="positionAppliedFor"
//               value={formData.positionAppliedFor}
//               onChange={handleInputChange}
//               className="mt-3 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//               placeholder="Enter position applied for"
//             />
//           </div>

//           {/* Personal Details */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Personal Details</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Title (Mr/Mrs/Miss/Ms)</label>
//                 <input
//                   type="text"
//                   name="title"
//                   value={formData.title}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Surname</label>
//                 <input
//                   type="text"
//                   name="surname"
//                   value={formData.surname}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">First Name(s)</label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Any Other Names</label>
//                 <input
//                   type="text"
//                   name="otherNames"
//                   value={formData.otherNames}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Address</label>
//                 <textarea
//                   name="address"
//                   value={formData.address}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Email Address</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Phone Number</label>
//                 <input
//                   type="tel"
//                   name="phoneNumber"
//                   value={formData.phoneNumber}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Preferred Contact Method</label>
//                 <input
//                   type="text"
//                   name="preferredContact"
//                   value={formData.preferredContact}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Dates Not Available for Interview</label>
//                 <textarea
//                   name="unavailableDates"
//                   value={formData.unavailableDates}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="2"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Eligible for Employment in Nigeria?</label>
//                 <select
//                   name="eligibleNigeria"
//                   value={formData.eligibleNigeria}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="">Select</option>
//                   <option value="YES">YES</option>
//                   <option value="NO">NO</option>
//                 </select>
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Documents for Eligibility</label>
//                 <textarea
//                   name="eligibilityDocuments"
//                   value={formData.eligibilityDocuments}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Criminal Convictions (Unspent)?</label>
//                 <select
//                   name="criminalConvictions"
//                   value={formData.criminalConvictions}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 >
//                   <option value="">Select</option>
//                   <option value="YES">YES</option>
//                   <option value="NO">NO</option>
//                 </select>
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Details of Unspent Convictions</label>
//                 <textarea
//                   name="unspentConvictionsDetails"
//                   value={formData.unspentConvictionsDetails}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Employment History (Current) */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Employment History - Current/Previous Employer</h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Name of Company</label>
//                 <input
//                   type="text"
//                   name="currentEmployerName"
//                   value={formData.currentEmployerName}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Address</label>
//                 <textarea
//                   name="currentEmployerAddress"
//                   value={formData.currentEmployerAddress}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="2"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Nature of Business</label>
//                 <input
//                   type="text"
//                   name="natureOfBusiness"
//                   value={formData.natureOfBusiness}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Job Title</label>
//                 <input
//                   type="text"
//                   name="jobTitle"
//                   value={formData.jobTitle}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Date Joined Organization</label>
//                 <input
//                   type="date"
//                   name="dateJoined"
//                   value={formData.dateJoined}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Date Started Current Position</label>
//                 <input
//                   type="date"
//                   name="dateStartedCurrent"
//                   value={formData.dateStartedCurrent}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Notice Period Required</label>
//                 <input
//                   type="text"
//                   name="noticePeriod"
//                   value={formData.noticePeriod}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Current Salary / Salary When Left</label>
//                 <input
//                   type="text"
//                   name="currentSalary"
//                   value={formData.currentSalary}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Main Tasks and Responsibilities</label>
//                 <textarea
//                   name="mainTasks"
//                   value={formData.mainTasks}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="4"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm font-medium text-gray-600">Reason for Leaving (if no longer employed)</label>
//                 <textarea
//                   name="reasonForLeaving"
//                   value={formData.reasonForLeaving}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Employment History Continued */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Employment History (Continued)</h2>
//             <p className="text-sm text-gray-500 mb-4">List in chronological order, starting with most recent.</p>
//             {formData.employmentHistory.map((entry, index) => (
//               <div key={index} className="border border-gray-200 p-4 mb-4 rounded-lg bg-gray-50">
//                 <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Employer's Name & Address</label>
//                     <textarea
//                       value={entry.employerName + '\n' + entry.employerAddress}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'employerName', e.target.value.split('\n')[0])}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       rows="2"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Type of Business</label>
//                     <input
//                       type="text"
//                       value={entry.businessType}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'businessType', e.target.value)}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Dates of Employment</label>
//                     <input
//                       type="text"
//                       value={entry.dates}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'dates', e.target.value)}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-gray-600">Job Title/Role</label>
//                     <input
//                       type="text"
//                       value={entry.jobTitle}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'jobTitle', e.target.value)}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     />
//                   </div>
//                   <div className="md:col-span-2">
//                     <label className="block text-sm font-medium text-gray-600">Reason for Leaving</label>
//                     <textarea
//                       value={entry.reasonForLeaving}
//                       onChange={(e) => handleEmploymentHistoryChange(index, 'reasonForLeaving', e.target.value)}
//                       className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       rows="2"
//                     />
//                   </div>
//                 </div>
//               </div>
//             ))}
//             <button
//               type="button"
//               onClick={addEmploymentEntry}
//               className="bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
//             >
//               Add Another Entry
//             </button>
//           </div>

//           {/* Education and Training */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Education and Training</h2>
//             <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Secondary School Attended</label>
//                 <input
//                   type="text"
//                   name="secondarySchool"
//                   value={formData.secondarySchool}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Examinations Passed</label>
//                 <input
//                   type="text"
//                   name="secondaryExams"
//                   value={formData.secondaryExams}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Grades</label>
//                 <input
//                   type="text"
//                   name="secondaryGrades"
//                   value={formData.secondaryGrades}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-3">
//                 <label className="block text-sm font-medium text-gray-600">Further and Higher Education</label>
//                 <textarea
//                   name="furtherEducation"
//                   value={formData.furtherEducation}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="3"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Professional Organization</label>
//                 <input
//                   type="text"
//                   name="professionalOrg"
//                   value={formData.professionalOrg}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Grade of Membership</label>
//                 <input
//                   type="text"
//                   name="gradeOfMembership"
//                   value={formData.gradeOfMembership}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div className="md:col-span-3">
//                 <label className="block text-sm font-medium text-gray-600">Job-Related Training</label>
//                 <textarea
//                   name="jobTraining"
//                   value={formData.jobTraining}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   rows="4"
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Skills, Abilities */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Skills, Abilities and Supporting Information</h2>
//             <div className="mt-4">
//               <textarea
//                 name="skillsInfo"
//                 value={formData.skillsInfo}
//                 onChange={handleInputChange}
//                 className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 rows="6"
//                 placeholder="Provide evidence of skills, knowledge, and experience..."
//               />
//             </div>
//           </div>

//           {/* References */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">References</h2>
//             <p className="text-sm text-gray-500 mb-4">Provide details of two referees.</p>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               <div>
//                 <h3 className="font-medium text-gray-700 mb-2">Referee 1</h3>
//                 <div className="space-y-3">
//                   <input
//                     type="text"
//                     name="ref1Name"
//                     value={formData.ref1Name}
//                     onChange={handleInputChange}
//                     placeholder="Name"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref1Company"
//                     value={formData.ref1Company}
//                     onChange={handleInputChange}
//                     placeholder="Company Name"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <textarea
//                     name="ref1Address"
//                     value={formData.ref1Address}
//                     onChange={handleInputChange}
//                     placeholder="Full Address"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     rows="2"
//                   />
//                   <input
//                     type="text"
//                     name="ref1JobTitle"
//                     value={formData.ref1JobTitle}
//                     onChange={handleInputChange}
//                     placeholder="Job Title"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref1Relationship"
//                     value={formData.ref1Relationship}
//                     onChange={handleInputChange}
//                     placeholder="Nature of Relationship"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="tel"
//                     name="ref1Phone"
//                     value={formData.ref1Phone}
//                     onChange={handleInputChange}
//                     placeholder="Phone"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref1Fax"
//                     value={formData.ref1Fax}
//                     onChange={handleInputChange}
//                     placeholder="Fax"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="email"
//                     name="ref1Email"
//                     value={formData.ref1Email}
//                     onChange={handleInputChange}
//                     placeholder="Email"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                 </div>
//               </div>
//               <div>
//                 <h3 className="font-medium text-gray-700 mb-2">Referee 2</h3>
//                 <div className="space-y-3">
//                   <input
//                     type="text"
//                     name="ref2Name"
//                     value={formData.ref2Name}
//                     onChange={handleInputChange}
//                     placeholder="Name"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref2Company"
//                     value={formData.ref2Company}
//                     onChange={handleInputChange}
//                     placeholder="Company Name"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <textarea
//                     name="ref2Address"
//                     value={formData.ref2Address}
//                     onChange={handleInputChange}
//                     placeholder="Full Address"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                     rows="2"
//                   />
//                   <input
//                     type="text"
//                     name="ref2JobTitle"
//                     value={formData.ref2JobTitle}
//                     onChange={handleInputChange}
//                     placeholder="Job Title"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref2Relationship"
//                     value={formData.ref2Relationship}
//                     onChange={handleInputChange}
//                     placeholder="Nature of Relationship"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="tel"
//                     name="ref2Phone"
//                     value={formData.ref2Phone}
//                     onChange={handleInputChange}
//                     placeholder="Phone"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="text"
//                     name="ref2Fax"
//                     value={formData.ref2Fax}
//                     onChange={handleInputChange}
//                     placeholder="Fax"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                   <input
//                     type="email"
//                     name="ref2Email"
//                     value={formData.ref2Email}
//                     onChange={handleInputChange}
//                     placeholder="Email"
//                     className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                 </div>
//               </div>
//             </div>
//             <p className="text-sm text-gray-500 mt-4 italic">Note: We will only contact referees with your prior agreement.</p>
//           </div>

//           {/* Personal Declaration */}
//           <div className="border-b border-gray-200 pb-6">
//             <h2 className="text-xl font-semibold text-gray-800">Personal Declaration</h2>
//             <p className="text-sm text-gray-600 mt-4 mb-4">
//               I confirm that, to the best of my knowledge, all the details I have given on this form are complete and true. I understand that if I give any false or misleading information, and/or I am unable to provide specifically requested details (of qualifications etc), it may lead to my dismissal (if I have already been given the job). I understand that any job offer depends on the supply of satisfactory references, evidence that I am eligible to work in Nigeria and sight of original certificates, as detailed in my application.
//             </p>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Signature</label>
//                 <input
//                   type="text"
//                   name="signature"
//                   value={formData.signature}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm font-medium text-gray-600">Date</label>
//                 <input
//                   type="date"
//                   name="date"
//                   value={formData.date}
//                   onChange={handleInputChange}
//                   className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Print Styles */}
//         <style jsx global>{`
//           @media print {
//             body * { visibility: hidden; }
//             .fixed, button, input[type="tel"] { display: none !important; }
//             div[ref="componentRef"] * { visibility: visible; }
//             div[ref="componentRef"] { position: absolute; left: 0; top: 0; width: 100%; }
//             .border-b { border-bottom: 1px solid #e5e7eb !important; }
//             .bg-gray-50 { background: none !important; }
//             input, textarea, select { border: 1px solid #d1d5db !important; background: none !important; }
//           }
//         `}</style>
//       </div>
//     </div>
//   );
// };

// export default JobApplicationFormShareable;





import React, { useRef, useState, useEffect } from 'react';
import html2pdf from 'html2pdf.js';
import axios from 'axios';

const JobApplicationFormShareable = ({ onClose }) => {
  const [formData, setFormData] = useState({
    positionAppliedFor: '',
    title: '',
    surname: '',
    firstName: '',
    otherNames: '',
    address: '',
    email: '',
    phoneNumber: '',
    preferredContact: '',
    unavailableDates: '',
    eligibleNigeria: '',
    eligibilityDocuments: '',
    criminalConvictions: '',
    unspentConvictionsDetails: '',
    currentEmployerName: '',
    currentEmployerAddress: '',
    natureOfBusiness: '',
    jobTitle: '',
    dateJoined: '',
    dateStartedCurrent: '',
    noticePeriod: '',
    currentSalary: '',
    mainTasks: '',
    reasonForLeaving: '',
    employmentHistory: [
      { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }
    ],
    secondarySchool: '',
    secondaryExams: '',
    secondaryGrades: '',
    furtherEducation: '',
    professionalOrg: '',
    gradeOfMembership: '',
    jobTraining: '',
    skillsInfo: '',
    ref1Name: '',
    ref1Company: '',
    ref1Address: '',
    ref1JobTitle: '',
    ref1Relationship: '',
    ref1Phone: '',
    ref1Fax: '',
    ref1Email: '',
    ref2Name: '',
    ref2Company: '',
    ref2Address: '',
    ref2JobTitle: '',
    ref2Relationship: '',
    ref2Phone: '',
    ref2Fax: '',
    ref2Email: '',
    signature: '',
    date: '',
  });

  const [whatsappNumber, setWhatsappNumber] = useState('');
  const componentRef = useRef(null);
  const [downloadCount, setDownloadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);


   const requiredFields = [
    'positionAppliedFor', 'title', 'surname', 'firstName', 'address', 'email', 'phoneNumber',
    'preferredContact', 'eligibleNigeria', 'criminalConvictions', 'currentEmployerName',
    'jobTitle', 'dateJoined', 'currentSalary', 'mainTasks', 'secondarySchool', 'secondaryExams',
    'furtherEducation', 'skillsInfo', 'ref1Name', 'ref1Company', 'ref1JobTitle', 'ref1Phone',
    'ref1Email', 'ref2Name', 'ref2Company', 'ref2JobTitle', 'ref2Phone', 'ref2Email',
    'signature', 'date'
  ];


    const isFormComplete = requiredFields.every(field => 
    formData[field] && formData[field].toString().trim() !== ""
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleEmploymentHistoryChange = (index, field, value) => {
    const updatedHistory = formData.employmentHistory.map((item, i) =>
      i === index ? { ...item, [field]: value } : item
    );
    setFormData(prev => ({ ...prev, employmentHistory: updatedHistory }));
  };

  const addEmploymentEntry = () => {
    setFormData(prev => ({
      ...prev,
      employmentHistory: [...prev.employmentHistory, { employerName: '', employerAddress: '', businessType: '', dates: '', jobTitle: '', reasonForLeaving: '' }]
    }));
  };

  const trackEvent = async (action) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}analytics/track-action`, {
        action,
        form: 'JobApplicationForm',
        timestamp: new Date().toISOString(),
      });
      fetchDownloadCount();
    } catch (error) {
      console.error('Tracking error:', error);
      const key = `jobForm_${action}_count`;
      const currentCount = parseInt(localStorage.getItem(key) || '0', 10);
      localStorage.setItem(key, currentCount + 1);
      if (action === 'download') setDownloadCount(currentCount + 1);
    }
  };

  const fetchDownloadCount = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}analytics/form-analytics`);
      setDownloadCount(response.data.downloadCount);
    } catch (error) {
      console.error('Error fetching download count:', error);
      const localCount = parseInt(localStorage.getItem('jobForm_download_count') || '0', 10);
      setDownloadCount(localCount);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDownloadCount();
  }, []);

  const handleDownload = () => {
     if (!isFormComplete) {
      alert("Please fill all required fields before downloading");
      return;
    }
    if (!componentRef.current) {
      alert('Error: Form content is not available for download.');
      return;
    }
    trackEvent('download');
    const element = componentRef.current;
    const opt = {
      margin: 1,
      filename: 'Job_Application_Form.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    html2pdf().set(opt).from(element).save();
  };

  const handlePrint = () => {
       if (!isFormComplete) {
      alert("Please complete the form before printing");
      return;
    }
    if (!componentRef.current) {
      alert('Error: Nothing to print. Please try again.');
      return;
    }
    trackEvent('print');
    window.print();
  };

  const handleShare = async () => {
     if (!isFormComplete) {
      alert("Please fill all required fields before sharing");
      return;
    }
    if (!navigator.share) {
      alert('Web Share API is not supported in your browser. Please download the PDF and share it manually.');
      return;
    }
    if (!componentRef.current) {
      alert('Error: Form content is not available for sharing.');
      return;
    }
    const element = componentRef.current;
    const opt = {
      margin: 1,
      filename: 'Job_Application_Form.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };
    try {
      const pdfBlob = await html2pdf().set(opt).from(element).toPdf().output('blob');
      const file = new File([pdfBlob], 'Job_Application_Form.pdf', { type: 'application/pdf' });
      trackEvent('share');
      await navigator.share({
        title: 'Job Application Form',
        text: 'Here is my completed job application form.',
        files: [file],
      });
    } catch (error) {
      console.error('Share error:', error);
      alert('Failed to share the form. Please download and share manually.');
    }
  };

  const handleSendToWhatsApp = () => {
     if (!isFormComplete) {
      alert("Please complete the form before sending");
      return;
    }
    if (!whatsappNumber) {
      alert('Please enter a valid WhatsApp number.');
      return;
    }
    const cleanedNumber = whatsappNumber.replace(/\D/g, '');
    const message = encodeURIComponent('Here is my job application form. Please find the PDF attached.');
    const whatsappUrl = `https://wa.me/${cleanedNumber}?text=${message}`;
    trackEvent('whatsapp');
    alert('Please download the PDF first and attach it in WhatsApp after clicking OK.');
    handleDownload();
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-5xl w-full max-h-[90vh] overflow-y-auto p-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-extrabold text-gray-900">Job Application Form</h1>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 text-2xl font-bold transition-colors">&times;</button>
        </div>

        {/* Action Buttons and Download Count */}
        <div className="flex flex-wrap gap-4 mb-8 items-center">
          <button
            onClick={handlePrint}
               disabled={!isFormComplete}
        className={`font-medium py-2 px-6 rounded-lg transition-colors flex items-center gap-2 ${
              isFormComplete 
                ? "bg-green-500 hover:bg-green-600 text-white" 
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            Print Form
          </button>
          <button
            onClick={handleDownload}
            disabled={!isFormComplete}
            className={`font-medium py-2 px-6 rounded-lg transition-colors flex items-center gap-2 ${
              isFormComplete 
                ? "bg-blue-500 hover:bg-blue-600 text-white" 
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            Download PDF
          </button>
          <button
            onClick={handleShare}
             disabled={!isFormComplete}
            className={`font-medium py-2 px-6 rounded-lg transition-colors flex items-center gap-2 ${
              isFormComplete 
                ? "bg-purple-500 hover:bg-purple-600 text-white" 
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            Share Form
          </button>
          <div className="flex items-center gap-2">
            <input
              type="tel"
              value={whatsappNumber}
              onChange={(e) => setWhatsappNumber(e.target.value)}
              placeholder="Enter WhatsApp Number"
              className="p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              onClick={handleSendToWhatsApp}
              disabled={!isFormComplete || !whatsappNumber}
              className={`font-medium py-2 px-6 rounded-lg transition-colors flex items-center gap-2 ${
                isFormComplete && whatsappNumber
                  ? "bg-teal-500 hover:bg-teal-600 text-white"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
              }`}
            >
              Send to WhatsApp
            </button>
          </div>
          <div className="ml-auto text-sm text-gray-500">
            {isLoading ? 'Loading download count...' : `Downloads: ${downloadCount}`}
          </div>
        </div>
           <div className="mb-6 p-4 rounded-lg bg-yellow-50 border border-yellow-300">
          <p className="text-sm font-medium text-yellow-800">
            {isFormComplete 
              ? "✅ All required fields completed — You can now download/print/share!"
              : `⚠️ Please fill all required fields (${requiredFields.length} total)`}
          </p>
        </div>

        {/* Form Content */}
        <div ref={componentRef} className="space-y-10">
          {/* Position Applied For */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800">Position Applied For</h2>
            <input
              type="text"
              name="positionAppliedFor"
              value={formData.positionAppliedFor}
              onChange={handleInputChange}
              className="mt-3 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter position applied for"
            />
          </div>

          {/* Personal Details */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800">Personal Details</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-600">Title (Mr/Mrs/Miss/Ms)</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Surname</label>
                <input
                  type="text"
                  name="surname"
                  value={formData.surname}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">First Name(s)</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Any Other Names</label>
                <input
                  type="text"
                  name="otherNames"
                  value={formData.otherNames}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Address</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Phone Number</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Preferred Contact Method</label>
                <input
                  type="text"
                  name="preferredContact"
                  value={formData.preferredContact}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Dates Not Available for Interview</label>
                <textarea
                  name="unavailableDates"
                  value={formData.unavailableDates}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Eligible for Employment in Nigeria?</label>
                <select
                  name="eligibleNigeria"
                  value={formData.eligibleNigeria}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Documents for Eligibility</label>
                <textarea
                  name="eligibilityDocuments"
                  value={formData.eligibilityDocuments}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Criminal Convictions (Unspent)?</label>
                <select
                  name="criminalConvictions"
                  value={formData.criminalConvictions}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Details of Unspent Convictions</label>
                <textarea
                  name="unspentConvictionsDetails"
                  value={formData.unspentConvictionsDetails}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                />
              </div>
            </div>
          </div>

          {/* Employment History (Current) */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800">Employment History - Current/Previous Employer</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-600">Name of Company</label>
                <input
                  type="text"
                  name="currentEmployerName"
                  value={formData.currentEmployerName}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Address</label>
                <textarea
                  name="currentEmployerAddress"
                  value={formData.currentEmployerAddress}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Nature of Business</label>
                <input
                  type="text"
                  name="natureOfBusiness"
                  value={formData.natureOfBusiness}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Job Title</label>
                <input
                  type="text"
                  name="jobTitle"
                  value={formData.jobTitle}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Date Joined Organization</label>
                <input
                  type="date"
                  name="dateJoined"
                  value={formData.dateJoined}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Date Started Current Position</label>
                <input
                  type="date"
                  name="dateStartedCurrent"
                  value={formData.dateStartedCurrent}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Notice Period Required</label>
                <input
                  type="text"
                  name="noticePeriod"
                  value={formData.noticePeriod}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Current Salary / Salary When Left</label>
                <input
                  type="text"
                  name="currentSalary"
                  value={formData.currentSalary}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Main Tasks and Responsibilities</label>
                <textarea
                  name="mainTasks"
                  value={formData.mainTasks}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="4"
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600">Reason for Leaving (if no longer employed)</label>
                <textarea
                  name="reasonForLeaving"
                  value={formData.reasonForLeaving}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                />
              </div>
            </div>
          </div>

          {/* Employment History Continued */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800">Employment History (Continued)</h2>
            <p className="text-sm text-gray-500 mb-4">List in chronological order, starting with most recent.</p>
            {formData.employmentHistory.map((entry, index) => (
              <div key={index} className="border border-gray-200 p-4 mb-4 rounded-lg bg-gray-50">
                <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Employer's Name & Address</label>
                    <textarea
                      value={entry.employerName + '\n' + entry.employerAddress}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'employerName', e.target.value.split('\n')[0])}
                      className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      rows="2"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Type of Business</label>
                    <input
                      type="text"
                      value={entry.businessType}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'businessType', e.target.value)}
                      className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Dates of Employment</label>
                    <input
                      type="text"
                      value={entry.dates}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'dates', e.target.value)}
                      className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Job Title/Role</label>
                    <input
                      type="text"
                      value={entry.jobTitle}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'jobTitle', e.target.value)}
                      className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-600">Reason for Leaving</label>
                    <textarea
                      value={entry.reasonForLeaving}
                      onChange={(e) => handleEmploymentHistoryChange(index, 'reasonForLeaving', e.target.value)}
                      className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      rows="2"
                    />
                  </div>
                </div>
              </div>
            ))}
            <button
              type="button"
              onClick={addEmploymentEntry}
              className="bg-gray-600 hover:bg-gray-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
            >
              Add Another Entry
            </button>
          </div>

          {/* Education and Training */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800">Education and Training</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
              <div>
                <label className="block text-sm font-medium text-gray-600">Secondary School Attended</label>
                <input
                  type="text"
                  name="secondarySchool"
                  value={formData.secondarySchool}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Examinations Passed</label>
                <input
                  type="text"
                  name="secondaryExams"
                  value={formData.secondaryExams}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Grades</label>
                <input
                  type="text"
                  name="secondaryGrades"
                  value={formData.secondaryGrades}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="md:col-span-3">
                <label className="block text-sm font-medium text-gray-600">Further and Higher Education</label>
                <textarea
                  name="furtherEducation"
                  value={formData.furtherEducation}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="3"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Professional Organization</label>
                <input
                  type="text"
                  name="professionalOrg"
                  value={formData.professionalOrg}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Grade of Membership</label>
                <input
                  type="text"
                  name="gradeOfMembership"
                  value={formData.gradeOfMembership}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="md:col-span-3">
                <label className="block text-sm font-medium text-gray-600">Job-Related Training</label>
                <textarea
                  name="jobTraining"
                  value={formData.jobTraining}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  rows="4"
                />
              </div>
            </div>
          </div>

          {/* Skills, Abilities */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800">Skills, Abilities and Supporting Information</h2>
            <div className="mt-4">
              <textarea
                name="skillsInfo"
                value={formData.skillsInfo}
                onChange={handleInputChange}
                className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                rows="6"
                placeholder="Provide evidence of skills, knowledge, and experience..."
              />
            </div>
          </div>

          {/* References */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800">References</h2>
            <p className="text-sm text-gray-500 mb-4">Provide details of two referees.</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="font-medium text-gray-700 mb-2">Referee 1</h3>
                <div className="space-y-3">
                  <input
                    type="text"
                    name="ref1Name"
                    value={formData.ref1Name}
                    onChange={handleInputChange}
                    placeholder="Name"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    name="ref1Company"
                    value={formData.ref1Company}
                    onChange={handleInputChange}
                    placeholder="Company Name"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <textarea
                    name="ref1Address"
                    value={formData.ref1Address}
                    onChange={handleInputChange}
                    placeholder="Full Address"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    rows="2"
                  />
                  <input
                    type="text"
                    name="ref1JobTitle"
                    value={formData.ref1JobTitle}
                    onChange={handleInputChange}
                    placeholder="Job Title"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    name="ref1Relationship"
                    value={formData.ref1Relationship}
                    onChange={handleInputChange}
                    placeholder="Nature of Relationship"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="tel"
                    name="ref1Phone"
                    value={formData.ref1Phone}
                    onChange={handleInputChange}
                    placeholder="Phone"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    name="ref1Fax"
                    value={formData.ref1Fax}
                    onChange={handleInputChange}
                    placeholder="Fax"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="email"
                    name="ref1Email"
                    value={formData.ref1Email}
                    onChange={handleInputChange}
                    placeholder="Email"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              <div>
                <h3 className="font-medium text-gray-700 mb-2">Referee 2</h3>
                <div className="space-y-3">
                  <input
                    type="text"
                    name="ref2Name"
                    value={formData.ref2Name}
                    onChange={handleInputChange}
                    placeholder="Name"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    name="ref2Company"
                    value={formData.ref2Company}
                    onChange={handleInputChange}
                    placeholder="Company Name"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <textarea
                    name="ref2Address"
                    value={formData.ref2Address}
                    onChange={handleInputChange}
                    placeholder="Full Address"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    rows="2"
                  />
                  <input
                    type="text"
                    name="ref2JobTitle"
                    value={formData.ref2JobTitle}
                    onChange={handleInputChange}
                    placeholder="Job Title"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    name="ref2Relationship"
                    value={formData.ref2Relationship}
                    onChange={handleInputChange}
                    placeholder="Nature of Relationship"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="tel"
                    name="ref2Phone"
                    value={formData.ref2Phone}
                    onChange={handleInputChange}
                    placeholder="Phone"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="text"
                    name="ref2Fax"
                    value={formData.ref2Fax}
                    onChange={handleInputChange}
                    placeholder="Fax"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <input
                    type="email"
                    name="ref2Email"
                    value={formData.ref2Email}
                    onChange={handleInputChange}
                    placeholder="Email"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>
            <p className="text-sm text-gray-500 mt-4 italic">Note: We will only contact referees with your prior agreement.</p>
          </div>

          {/* Personal Declaration */}
          <div className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-800">Personal Declaration</h2>
            <p className="text-sm text-gray-600 mt-4 mb-4">
              I confirm that, to the best of my knowledge, all the details I have given on this form are complete and true. I understand that if I give any false or misleading information, and/or I am unable to provide specifically requested details (of qualifications etc), it may lead to my dismissal (if I have already been given the job). I understand that any job offer depends on the supply of satisfactory references, evidence that I am eligible to work in Nigeria and sight of original certificates, as detailed in my application.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-600">Signature</label>
                <input
                  type="text"
                  name="signature"
                  value={formData.signature}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600">Date</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Print Styles */}
        <style jsx global>{`
          @media print {
            body * { visibility: hidden; }
            .fixed, button, input[type="tel"] { display: none !important; }
            div[ref="componentRef"] * { visibility: visible; }
            div[ref="componentRef"] { position: absolute; left: 0; top: 0; width: 100%; }
            .border-b { border-bottom: 1px solid #e5e7eb !important; }
            .bg-gray-50 { background: none !important; }
            input, textarea, select { border: 1px solid #d1d5db !important; background: none !important; }
          }
        `}</style>
      </div>
    </div>
  );
};

export default JobApplicationFormShareable;























































